/* eslint-disable react/react-in-jsx-scope */
import { useState , useEffect , useRef ,lazy} from "react";
import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import { Button, buttonVariants } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { RefreshCw, Send , Loader , FileBadge, ChevronsRight, Trash, Lock, Check, Edit } from "lucide-react";
import { useTranslation } from "react-i18next";
import usePostData from "@/hooks/usePostData";
import FinancerInput from "@/components/fields/FinancerInput";
import ProjectInput from "@/components/fields/ProjectInput";
import { useAuth } from "@/auth/hooks/useAuth";
import SignatureCanvas from "react-signature-canvas";
import { toast } from '@/components/ui/use-toast';
import n2words from 'n2words';
import { useNavigate, useLocation } from "react-router-dom";
import { useHidePostActions } from "@/auth/hooks/useHidePostActions";



type Financeur = {
  id:string;
  name:string;
};
type Projet = {
  id:string;
  name:string;
};

type File = {
  name:string;
  link:string;
};

type Certificat = {
  id: string;
  financeur: Financeur;
  projet: Projet;
  montant:string;
  date:string;
  file:File;
};

const LoadingModal = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "certificats",
  });
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center shadow-xl w-[350px]">
        {/* Loader animé */}
        <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mb-6"></div>

        {/* Texte */}
        <h2 className="text-lg font-semibold text-gray-800 mb-2">
          {t("Veuillez patienter...")}
        </h2>
        <p className="text-gray-600 text-center text-sm">
          {t("Le calcul est en cours. Cette opération peut prendre quelques secondes.")}
        </p>
      </div>
    </div>
  );
};

export default function CerfaForm() {
  const { user} = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation("dashboard", {
    keyPrefix: "certificats",
  });
  const [page, setPage] = useState(1);
  const { postData } = usePostData();
  const hidePostActions = useHidePostActions();
  const [financer, setFinancer] = useState(null);
  const [createdProject, setCreatedProject] = useState(null);
  const [montant, setMontant] = useState<number|string>("");
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [disableProject, setDisableProject] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [signaturePP, setSignaturePP] = useState("");
  const [isEmpty, setIsEmpty] = useState(true);
  const [pageNumber, setPageNumber] = useState(4);
  const [isLoadingFinancer, setIsLoadingFinancer] = useState(false);
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const [imageSaved, setImageSaved] = useState(false);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const projectId = params.get("id");
  const [makeCalcul, setMakeCalcul] = useState(false); 
  const [isFromSuiviFinancement, setIsFromSuiviFinancement] = useState(false);
  const sigCanvas = useRef(null);
  const [isDisabled, setIsDisabled] = useState(true);
  useEffect(() => {
    setIsDisabled(
      financer === null ||
      createdProject === null ||
      montant === "" ||
      dateDebut === "" ||
      !user
    );
  }, [financer, createdProject, montant, dateDebut, user]);
  // const isDisabled =
  //   financer === null || createdProject === null || montant === "" || dateDebut === "" || !user;
  useEffect(() => {
  if (isEditing && sigCanvas.current) {
    sigCanvas.current.clear();
    setIsEmpty(true);
  }
}, [isEditing]);

  const clear = () => {
    sigCanvas.current.clear();
    setSignaturePP("");
    update("signature", "");
    setIsEmpty(true);
    
  };

  const save = () => {
    setImageSaved(true);
    const canvas = sigCanvas.current.getCanvas();
    const imageData = canvas.toDataURL("image/png");
    setSignaturePP(imageData);
    update("signature", imageData);
    setTimeout(() => {
      setImageSaved(false)}, 2000);
  };

  const cancelEdit = () => {
    // Recharger l'image initiale
    if (user?.coworker === true) {
      fetchImageSignature("");
      setIsEditing(false);
      return;
    }
    update("signature", user.signature);
    setSignaturePP(user.signature);
    fetchImageSignature(user.signature);
    setIsEditing(false);
  };

  

  // États partagés pour tout le formulaire
  const [form, setForm] = useState({
    // Page 1 - Organisme bénéficiaire
    numeroOrdre: "",      
    denomination: "",     
    siren: "",            
    adresse: "",          
    rue: "",
    codePostal: "",       
    commune: "",          
    pays: "",             
    objet: "",            

    // Page 2 - Donateur
    entrepriseNom: "",    
    formeJuridique: "",   
    entrepriseSiren: "",  
    entrepriseAdresse: "", 
    entrepriseRue: "",
    entrepriseCP: "",     
    entrepriseCommune: "", 

    // Page 3 - Dons / versements
    montantNature: "",    
    montantNatureLettre: "",
    montantVersement: "", 
    montantVersementLettre: "", 
    montantTotal: "",    
    montantTotalLettre: "", 

    // Page 4 - Dates
    dateDebut: "",        
    dateFin: "",         

    // for database 
    signature: "",
    financerId: "",
    projectId: "",
    dataSuivi: []
  });

  const update = (key: string, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const calculInformationsFunding = async (mDataTemp) => {
    const urlApi = `${import.meta.env.VITE_IP_API}/api/calcul-funding-cerfa`;
    const res = await postData({
        url: urlApi,
        data: {
          "projectId": projectId,
          "financerId": mDataTemp.financierId,
          "realFunding": mDataTemp.paiements
        },
    });
    if(res) {

      setCreatedProject(res.projec);
      setFinancer(res.financer);
      setMontant(Math.round(res.calcul.montantTotal));
      const dateDebutAPI = res.calcul.dateDebut;
      const dateFinAPI = res.calcul.dateFin;
      setDateDebut(dateDebutAPI.split(" ")[0]);
      if(dateDebutAPI != dateFinAPI ) {
        setDateFin(dateFinAPI.split(" ")[0])
      }
      setMakeCalcul(false);
    }
  }

  useEffect(() => {
    const dataProject = sessionStorage.getItem("certificatResult");
    if(projectId && dataProject) {
      setMakeCalcul(true);
      calculInformationsFunding(JSON.parse(dataProject));
      setIsFromSuiviFinancement(true);
      const parsedData = JSON.parse(dataProject);
      update("dataSuivi", parsedData.paiements);
    }
  }, []);

  useEffect(() => {
    if(makeCalcul) {
      setMakeCalcul(true);
    }
  }, [makeCalcul]);

  useEffect(() => {
    if(!isFromSuiviFinancement) {
      setCreatedProject(null)
    }
    
    if(financer) {
      if(financer.siret || financer.structureName) {
        fetchEnterpriseInfos(false, financer.siret ?? financer.structureName);
      }
      update("entrepriseNom", financer.fullname);
      setDisableProject(false);
    } else {
      update("entrepriseNom", "");
      setDisableProject(true);
    }
    
  }, [financer]);

  useEffect(() => {
    if(createdProject) {
        update("objet", "Financement du projet "+createdProject.name);
        update("projectId", createdProject.id);
        setDisableProject(false);
    } else {
      update("objet", "");
      update("projectId", "");
      setDisableProject(true);
    }
    
  }, [createdProject]);

  useEffect(() => {
    
    if(user) {
      
      update("denomination", user.fullname);
      if(user.Organisation) {
        update("denomination", user.Organisation.name);
        update("siren", user.Organisation.siren);
        update("adresse", user.Organisation.numRue);
        update("rue", user.Organisation.rue);
        update("codePostal", user.Organisation.codePostale);
        update("pays", user.Organisation.pays);
        update("commune", user.Organisation.ville);
      } else {
        fetchEnterpriseInfos(true, user.siret ?? user.structureName);
      }

      if(user.coworker === true) {
        fetchImageSignature("");
      } else if(user.signature) {
        update("signature", user.signature);
        setSignaturePP(user.signature);
        fetchImageSignature(user.signature);
      }
    } else {
      update("denomination", "");
    }
  }, [user]);



  useEffect(() => {
    if(financer) {
      update("financerId", financer.id);
    } else {
      update("financerId", "");
    }
  }, [financer]);

  useEffect(() => {
      update("dateDebut", dateDebut);
  }, [dateDebut]);
  useEffect(() => {
      update("dateFin", dateFin);
  }, [dateFin]);
  useEffect(() => {
      update("montantTotal", montant);
      if(montant != "") {
        const enLettres = n2words(montant, { lang: 'fr' });
        update("montantTotalLettre", enLettres+" Euros");
      }
      
  }, [montant]);

  const fetchImageSignature = async (query) => {
      // setLoading(true);
      let token = localStorage.getItem("jwtToken");
      if(token === null) {
        token = sessionStorage.getItem("jwtToken");
      }
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_ENDPOINT}/user/signature-file?filename=${query}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
        console.log("filename-------",response.headers.get("X-Signature-Filename"));

        if(response.headers.get("X-Signature-Filename")) {
          const filename = response.headers.get("X-Signature-Filename");
          console.log("filename-------",filename);
          update("signature", filename);
          setSignaturePP(filename);
        }
        
        
      } catch (error) {
        console.error("Erreur lors de la récupération des résultats :", error);
        // setResults([]);
      } 
    };

  const fetchEnterpriseInfos = async (fromPP,siret) => {
      // setLoading(true);
      if(fromPP) {
        setIsLoadingUser(true);
      } else{
        setIsLoadingFinancer(true);
      }
      let token = localStorage.getItem("jwtToken");
      if(token === null) {
        token = sessionStorage.getItem("jwtToken");
      }
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_ENDPOINT}/financer/search/informations?search=${siret}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const dataAPI = await response.json();
        if(dataAPI && !fromPP) {
          update("formeJuridique", dataAPI["company"]["forme_juridique"] );
          update("entrepriseSiren", dataAPI["company"]["siren"] );
          update("entrepriseAdresse", dataAPI["company"]["siege"].numero_voie);
          update("entrepriseRue", dataAPI["company"]["siege"].libelle_voie );
          update("entrepriseCP", dataAPI["company"]["siege"].code_postal);
          update("entrepriseCommune", dataAPI["company"]["siege"].ville);
        } else if(dataAPI && fromPP) {
          update("siren", dataAPI["company"]["siren"] );
          update("adresse", dataAPI["company"]["siege"].numero_voie);
          update("rue", dataAPI["company"]["siege"].libelle_voie );
          update("codePostal", dataAPI["company"]["siege"].code_postal);
          update("commune", dataAPI["company"]["siege"].ville);
          update("pays", dataAPI["company"]["siege"].pays);
        }
        if(fromPP) {
          setIsLoadingUser(false);
        } else{
          setIsLoadingFinancer(false);
        }

        // setResults(data["hydra:member"] || []);
      } catch (error) {
        if(fromPP) {
          setIsLoadingUser(false);
        } else{
          setIsLoadingFinancer(false);
        }
      }
    };

  const submitFormulaire = async () => {
    setIsLoading(true);
    const urlApi = `${import.meta.env.VITE_IP_API}/api/generate-new-certificate`;
    const res = await postData({
        url: urlApi,
        data: {
          form
        },
    });
    if(res) {
      toast({
          title: 'Success',
          description: t('Certificat généré avec succès'),
          duration: 4000,
      });
      window.location.href = "/dashboard/certificats";
    }
    setIsLoading(false);
  };

  return (
    <div>

      <ReactBreadcrumb
        items={[
          {
            href: ``,
            name: "Mes reçus fiscaux",
          },
        ]}
        isTruncated={false} />

      <div className="flex flex-wrap gap-5 items-center justify-between mt-5">
        <h1
          className="mb-2 mt-4 text-[24px] font-medium inline-block"
          id="program-title"
        >
          {t("Formulaire")}
        </h1>
      </div> 

      {makeCalcul && (<LoadingModal/>)}

      <div className="mb-6 p-4 bg-[#ebf6e9] border border-[#cde9cc] rounded-lg shadow-sm">
        <h1 className="text-xl font-semibold text-[#1d5214] flex items-center gap-2">
          <svg className="w-6 h-6 text-[#1d5214]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m2 0a2 2 0 100-4 2 2 0 000 4zm0 0a2 2 0 11-4 0 2 2 0 014 0zm0 0v6a2 2 0 11-4 0v-6" />
          </svg>
          {t("Formulaire de reçu")} CERFA 2041-MEC-SD
        </h1>
        <p className="text-sm text-[#1d5214] mt-1">
          {t("Veuillez remplir ce formulaire avec soin.")}
        </p>
      </div>
    
      <div className="w-full max-w-5xl p-6 border rounded-lg shadow-md space-y-6 mt-3">
         {page === 1 && (
          <div id="addFinancementContent">
            <h2 className="text-xl font-semibold mb-4">1. {t("Informations sur le financement")}</h2>
            <div className=" w-full gap-4">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("Montant")}
                  </label>
                  <Input
                    type="number"
                    placeholder="Montant"
                    value={montant}
                    onChange={(e) => setMontant(parseFloat(e.target.value))}
                    required
                    step="0.01"
                    className={""}
                  />
                </div>
            </div>
            <br/>
            <div className="block mb-2 flex w-full gap-4 mt-2">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("Financeur")}
                </label>
                {!isFromSuiviFinancement && (
                <FinancerInput
                  className="mt-1"
                  selected={financer}
                  handleChange={(value) => {
                      setFinancer(value);
                  }}
                  placeholder={t("Saisissez un financeur...")}
                />)}
                {isFromSuiviFinancement && (
                  <div className={"mx-auto w-full"}>
                    <input
                      type="text"
                      value={financer?.fullname}
                      readOnly={true}
                      className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    />
                  </div>
                )}
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("Projet")}
                </label>
                {!isFromSuiviFinancement && (
                  <ProjectInput
                    className="mt-1"
                    selected={financer}
                    handleChange={(value) => {
                        setCreatedProject(value);
                    }}
                    idFinancer={financer ? financer.id : null}
                    disableProject={disableProject}
                  />
                )}
                {isFromSuiviFinancement && (
                  <div className={"mx-auto w-full"}>
                    <input
                      type="text"
                      value={createdProject?.name}
                      readOnly={true}
                      className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    />
                  </div>
               )}
               </div>
            </div>
            <br/> 
            <h3 className="font-bold text-gray-700 tracking-wide border-b-2 border-[#1d5214] pb-1 mt-6 mb-4">
              {t("Date ou période au cours de laquelle")} <span className="text-red-500">*</span>
            </h3>
               
            <div className="flex w-full gap-4 mt-4">
                {/* Date de début */}
                <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("Du ou le")}
                    </label>
                    <input
                      type="date"
                      value={dateDebut}
                      max={dateFin || undefined}
                      onChange={(e) => setDateDebut(e.target.value)}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                    />
                </div>
    
                {/* Date de fin */}
                <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("au")}
                    </label>
                    <input
                      type="date"
                      value={dateFin}
                      min={dateDebut || undefined}
                      onChange={(e) => setDateFin(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                    />
                </div>
            </div>

            {/* Feedback utilisateur (facultatif mais sympa) */}
            {dateDebut && (
            <div className="mt-2 text-sm text-gray-600">
                {dateFin ? (
                <>{t("Versement du")} <strong>{dateDebut}</strong> {t("au")} <strong>{dateFin}</strong></>
                ) : (
                <>{t("Versement à la date du")} <strong>{dateDebut}</strong></>
                )}
            </div>
            )}   

            <p className="mt-4 text-sm text-gray-600">
              <span className="text-red-500">*</span>
              <i className="text-xs">{t("L’organisme bénéficiaire peut établir")}
              </i>
            </p> 
            
              
          </div>)}

        {page === 2 && (
          <>
            <h2 className="text-xl font-semibold mb-4">2. {t("Organisme bénéficiaire")}</h2>

            {/* a1 - Numéro d’ordre du reçu */}
            <label className="block mb-2">
              {t("Numéro d’ordre du reçu")} 
              <input
                type="text"
                value={form.numeroOrdre}
                onChange={(e) => update("numeroOrdre", e.target.value)}
                className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm focus:ring focus:ring-indigo-500"
                required
              />
            </label>

            {/* a2 - Dénomination de l’organisme */}
            <label className="block mb-2">
              {t("Dénomination de l’organisme")} 
              <input
                type="text"
                value={form.denomination}
                onChange={(e) => update("denomination", e.target.value)}
                className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm"
                disabled={true}
                required
              />
            </label>

            {/* a8 - Numéro SIREN ou RNA */}
            <label className="block mb-2">
              {t("Numéro SIREN ou RNA")} 
              <input
                type="text"
                value={form.siren}
                onChange={(e) => update("siren", e.target.value)}
                className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm"
                required
              />
            </label>

            {/* a9-a13 - Adresse */}
            <h3 className="font-bold text-gray-700 tracking-wide border-b-2 border-[#1d5214] pb-1 mt-6 mb-4">
              {t("Siège")}
            </h3>
            <div className="flex gap-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">
                  {t("Numéro de voie")}
                  <input
                    type="text"
                    value={form.adresse}
                    onChange={(e) => update("adresse", e.target.value)}
                    className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm"
                    required
                  />
                </label>
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">
                  {t("Rue")}
                  <input
                    type="text"
                    value={form.rue}
                    onChange={(e) => update("rue", e.target.value)}
                    className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm"
                    required
                  />
                </label>
              </div>
            </div>
            

            <div className="flex gap-4">
              {/* a11 - Code postal */}
              <div className="w-1/3">
                <label className="block text-sm font-medium mb-1">{t("Code postal")}</label>
                <input
                  type="text"
                  value={form.codePostal}
                  onChange={(e) => update("codePostal", e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg shadow-sm"
                />
              </div>

              {/* a12 - Commune */}
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">{t("Commune")} </label>
                <input
                  type="text"
                  value={form.commune}
                  onChange={(e) => update("commune", e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg shadow-sm"
                />
              </div>

              {/* a13 - Pays */}
              <div className="w-1/3">
                <label className="block text-sm font-medium mb-1">{t("Pays")}</label>
                <input
                  type="text"
                  value={form.pays}
                  onChange={(e) => update("pays", e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg shadow-sm"
                />
              </div>
            </div>

            {/* a14 - Objet */}
            <label className="block mb-2 mt-4">
              {t("Objet du don")}
              <textarea
                value={form.objet}
                onChange={(e) => update("objet", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg shadow-sm"
                disabled={true}
                rows={3}
              />
            </label>
          </>
        )}

        {page === 3 && (
          <>
            <h2 className="text-xl font-semibold mb-4">3. {t("Entreprise donatrice")}</h2>

            {/* b1 */}
            <label className="block mb-2">
              {t("Nom de l’entreprise")}
              <input
                type="text"
                value={form.entrepriseNom}
                onChange={(e) => update("entrepriseNom", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg shadow-sm"
                disabled={true}
              />
            </label>

            {/* b2 */}
            <label className="block mb-2">
              {t("Forme juridique")}
              <input
                type="text"
                value={form.formeJuridique}
                onChange={(e) => update("formeJuridique", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg shadow-sm"
              />
            </label>

            {/* b3 */}
            <label className="block mb-2">
              {t("Numéro SIREN ou RNA")}
              <input
                type="text"
                value={form.entrepriseSiren}
                onChange={(e) => update("entrepriseSiren", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg shadow-sm"
              />
            </label>

            <h3 className=" font-bold text-gray-700 tracking-wide border-b-2 border-[#1d5214] pb-1 mt-6 mb-4">
              {t("Siège")}
            </h3>

            {/* b4-b5 */}
            <div className="flex gap-4">
              <div className="w-1/2">
                <label className="block mb-1">
                  {t("Numéro de voie")}
                  <input
                    type="text"
                    value={form.entrepriseAdresse}
                    onChange={(e) => update("entrepriseAdresse", e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg shadow-sm"
                  />
                </label>
              </div>
              
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">
                  {t("Rue")}
                  <input
                    type="text"
                    value={form.entrepriseRue}
                    onChange={(e) => update("entrepriseRue", e.target.value)}
                    className="w-full mt-1 px-3 py-2 border rounded-lg shadow-sm"
                    required
                  />
                </label>
              </div>
            </div>

            <div className="flex gap-4">
              {/* b6 */}
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">{t("Code postal")}</label>
                <input
                  type="text"
                  value={form.entrepriseCP}
                  onChange={(e) => update("entrepriseCP", e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg shadow-sm"
                />
              </div>

              {/* b7 */}
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1">{t("Commune")}</label>
                <input
                  type="text"
                  value={form.entrepriseCommune}
                  onChange={(e) => update("entrepriseCommune", e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg shadow-sm"
                />
              </div>
            </div>
          </>
        )}

        {pageNumber === 4 && page === 4 && (
          <>
            <h2 className="text-xl font-semibold mb-4">4. {t("Signature")}</h2>

            <div>
    {/* Mode affichage image */}
    {!isEditing && imageSrc && (
      <div className="relative border border-gray-300 w-[500px] h-[200px] group">
        <img
          src={imageSrc}
          alt="Signature"
          className="w-full h-full object-contain"
        />

        {/* Navbar flottante au hover */}
        <div
          className="
            absolute top-0 left-0 right-0 
            bg-black/60 text-white 
            opacity-0 group-hover:opacity-100 
            transition-opacity duration-300 
            flex justify-end p-2"
        >
          <Button
            className={buttonVariants({ variant: "default" })}
            size="sm"
            onClick={() => {
              setIsEditing(true);
              setSignaturePP("");
              update("signature", "");
            }}
          >
            <Edit className="w-4 h-4 mr-2" />
            {t("Modifier la signature")}
          </Button>
        </div>
      </div>
    )}

    {/* Mode édition */}
    {(isEditing || !imageSrc) && (
      <>
        <SignatureCanvas
          penColor="black"
          backgroundColor="#ffff"
          canvasProps={{
            width: 500,
            height: 200,
            className: "signature-canvas",
            style: {
              border: "1px solid #ccc",
              backgroundColor: "#f0f0f0",
            },
          }}
          ref={sigCanvas}
          onEnd={() => {
            if (sigCanvas.current) {
              setIsEmpty(sigCanvas.current.isEmpty())
            }
          }}
        />
        <br />

        <div className="flex gap-2">
          {!isEmpty && (
          <Button onClick={clear} variant="destructive">
            <Trash className="w-4 h-4 mr-2" />
            {t("Effacer")}
          </Button>)}

          {imageSaved ? (
            <Button disabled>
              <Loader className="w-4 h-4 mr-2 animate-spin" />
              {t("Enregistrement de l'image")}
            </Button>
          ) : (
            <>
              <Button
                className={buttonVariants({ variant: "default" })}
                onClick={save}
                disabled={isEmpty}
              >
                <Lock className="w-4 h-4 mr-2" />
                {t("Appliquer les modifications")}
              </Button>
              {imageSrc && (
                <Button
                  variant="secondary"
                  onClick={cancelEdit}
                >
                  {t("annuler")}
                </Button>
              )}
            </>
          )}
        </div>
      </>
    )}
  </div>
        </>
      )}

      {/* Pagination controls */}
        <div className="flex justify-between pt-6">
          {page > 1 && (
            <button
              onClick={() => setPage(page - 1)}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
            >
              {t("Précédent")}
            </button>
          )}

          {page < pageNumber ? (
            <Button className={buttonVariants({ variant: "default" })} onClick={() => setPage(page + 1)} disabled={isDisabled || isLoadingFinancer || isLoadingUser}>
                <ChevronsRight className="w-4 h-4 mr-2" />
                {isLoadingFinancer || isLoadingUser ? t("Mise à jour des informations") : t("Suivant")}
            </Button>
          ) : (
            !hidePostActions && (
              <Button
                onClick={() => {
                  submitFormulaire();
                }}
                disabled={isLoading || isDisabled || signaturePP === ""}
              >
                {isLoading ? (
                  <>
                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                    {t("Envoi en cours")}
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4 mr-2" />
                    Générer le reçu
                  </>
                )}
              </Button>
            )
          )}
        </div>
      </div>
    </div>
  );
}
